export const checkButton = (payMethod, user, isPayzenModule, store) => {

  const stripeCbCheck =
    !isPayzenModule &&
    user.creditCard &&
    Object.keys(user.creditCard).length &&
    user.creditCard[0] &&
    user.creditCard[0].pm &&
    user.creditCard[0].pm.length > 0;
  const payzenCbCheck =
    isPayzenModule &&
    user.payzenCreditCards &&
    Object.keys(user.payzenCreditCards).length &&
    user.payzenCreditCards[0]?.pm &&
    user.payzenCreditCards[0].pm.length > 0;
  const payzenConecsCheck =
    isPayzenModule &&
    user.payzenConecsCreditCards &&
    Object.keys(user.payzenConecsCreditCards).length &&
    user.payzenConecsCreditCards[0]?.pm &&
    user.payzenConecsCreditCards[0].pm.length > 0;

  switch (payMethod) {
    case 'cb':
      return isPayzenModule ? payzenCbCheck : stripeCbCheck;
    case 'conecs':
      return isPayzenModule && store?.paymentsGateway?.TR === 'payzen'
        ? payzenConecsCheck
        : user.conecs && Object.keys(user.conecs).length > 0;
    case 'edenred':
      return user.edenred && Object.keys(user.edenred).length > 0;
    default:
      return false;
  }
};
